<template>
	<v-skeleton-loader width="100%" max-width="555" v-if="this.isLoading" type="card">
	</v-skeleton-loader>
	<div v-else class="mb-5 mt-3">
		<div class="mt-1" v-for="attachment in this.post.uploads" :key="attachment.upload_id">
			<FileListComponent :attachment="attachment" />
		</div>
	</div>
</template>

<script>
import FileListComponent from '@/components/FileListComponent.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
	components: { FileListComponent },
	methods: {
		...mapActions('post', ['getPost']),
		...mapActions('app', ['setPageTitle']),
	},
	computed: {
		...mapGetters('post', ['post', 'isLoading', 'postNotFound']),
	},
	mounted() {
		this.setPageTitle('Attachments')
	},
	created() {
		this.getPost(this.$route.params.id)
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
}
</script>
<style lang="scss"></style>
